"use client";

import { useEffect } from "react";

export default function DisablePwaPrompt() {
  useEffect(() => {
    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
    };
  }, []);

  return null; // This component doesn't render anything
}
